import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IncidentsTypesListComponent } from './incidents-types-list/incidents-types-list.component';
import { IncidentsTypesDetailComponent } from './incidents-types-detail/incidents-types-detail.component';

const routes: Routes = [
    {
        path: 'incidentsTypes',
        children: [
            { path: '', component: IncidentsTypesListComponent }
        ]
    },
    {
        path: 'incidentsTypes/:id',
        children: [
            { path: '', component: IncidentsTypesDetailComponent }
        ]
    },
    {
        path: 'incidentsTypes/:id/:source',
        children: [
            { path: '', component: IncidentsTypesDetailComponent }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class IncidentsTypesRoutingModule { }
